import moment from "moment";

import {
  CsvFieldMapping,
  CsvImportField,
  mappedCsvValue,
} from "Components/Common/CsvImport/csvImportTypes";

export const GOVERNMENT_REQUEST_IMPORT_FIELDS: CsvImportField[] = [
  { key: "SomaliaRegion", label: "Somalia Region", required: true },
  {
    key: "MinistryDepartmentAgency",
    label: "Ministry / Department / Agency (MDA)",
    required: true,
  },
  { key: "Sector", label: "Sector" },
  {
    key: "PartnerAgency",
    label: "Partner/UN Agency",
    required: true,
  },
  {
    key: "RequestTitle",
    label: "Project Name/ Request Title Description",
    required: true,
  },
  { key: "ProjectId", label: "Project ID" },
  { key: "ProposedBudget", label: "Proposed Budget (USD)" },
  { key: "RequestStatus", label: "Request Status" },
  { key: "RequestDate", label: "Request Date", required: true },
  { key: "StartDate", label: "Duration: Start date" },
  { key: "EndDate", label: "Duration: End date" },
  { key: "SupportedPositions", label: "No of Supported Positions" },
  { key: "DataProvidedBy", label: "Data Provided by" },
  { key: "TypeOfRequest", label: "Type of Request" },
];

function normalizeDate(value: string | null): string | null {
  if (!value) return null;
  const date = moment(
    value,
    ["D/M/YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "D MMM YYYY"],
    true
  );
  return date.isValid() ? date.format("YYYY-MM-DD") : value;
}

export function mapGovernmentRequestImportRow(
  row: Record<string, string>,
  mappings: CsvFieldMapping
) {
  const get = (key: string) => mappedCsvValue(row, mappings, key);

  return {
    region: get("SomaliaRegion"),
    mda: get("MinistryDepartmentAgency"),
    sector: get("Sector"),
    agency: get("PartnerAgency"),
    requestTitle: get("RequestTitle"),
    projectId: get("ProjectId"),
    totalValueOfRequest: get("ProposedBudget"),
    fundingStatus: get("RequestStatus"),
    dateOfRequest: normalizeDate(get("RequestDate")),
    startDate: normalizeDate(get("StartDate")),
    endDate: normalizeDate(get("EndDate")),
    noOfPositionsRequested: get("SupportedPositions"),
    dataProvidedBy: get("DataProvidedBy"),
    typeOfRequest: get("TypeOfRequest"),
  };
}
